import { z } from 'zod';
import { zLinklyRequestType } from '../enums';

/**
 * Linkly API uses a callback pattern where Linkly server calls back to our server with data requested.
 * Only POST requests are supported. If you need to make a GET request, then use a Convex action instead.
 */
export const linklyRequestSchema = z.object({
  /**
   * A Linkly session can have multiple requests.
   */
  sessionUuid: z.string(),
  url: z.string(),
  /** `body` will be null for GET requests */
  body: z.record(z.string(), z.any()).nullable().default(null),
  runError: z.string().nullable().default(null),
  runId: z.string().nullable().default(null),
  /**
   * The time at which as HTTP 202 (Accepted) was received from the Linkly server.
   */
  acceptedAt: z.number().nullable().default(null),
  /**
   * This should match the value of `ResponseType` in the Linkly API response.
   */
  requestType: zLinklyRequestType,

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type LinklyRequest = z.output<typeof linklyRequestSchema>;

export const linklyRequestStrictSchema = linklyRequestSchema.safeExtend({
  sessionUuid: z.guid(),
});

export const linklyRequestCvxSchema = linklyRequestSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type LinklyRequestCvx = z.output<typeof linklyRequestCvxSchema>;
